export const minLength = 10;
export const maxLength = 10;
export const pattern = /^[0-9A-Za-z]*$/;
export const label = 'Промокод (не обов’язково)';
export const errors = {
  pattern: 'Містить недопустимий символ',
  minlength: 'Введіть, будь ласка, повний № промокоду',
};
